import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { layoutsKeys } from 'app/queries/layouts/layoutsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof layoutsKeys.optionsByOrganization>>;

export const createFetchOrganizationLayoutOptionsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        AdminService.getOrganizationLayoutsAsAdmin({
          oid: organizationId,
          orderBy: 'name',
          orderType: 'asc',
          pageNo: '0',
          pageSize: '100',
          search: '',
        }),
        signal,
      ),
    );
